import * as React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NavBar from './components/NavBar'
import FrontPage from './containers/FrontPage'
import Footer from './components/Footer'

const renderPaths = () => {
  return (
    <main className="main-container">
      <NavBar />
      <Route path="/" component={FrontPage} />
      <Footer />
    </main>
  )
}

export const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="" render={renderPaths} />
    </Switch>
  </BrowserRouter>
)



// WEBPACK FOOTER //
// ./src/routes.tsx